export default {
      id: "ic_arrow_next-usage",
      viewBox: "0 0 7 11",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#ic_arrow_next",
      toString: function () {
        return this.url;
      }
    }